module.exports = __webpack_public_path__ + "static/img/company2.9828961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company2.png
// module id = DmiK
// module chunks = 44